export default "/images/logo_retina.png?24a72a9df9780da7e2275eb78a202f11";